import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Editor } from 'react-draft-wysiwyg';
import { convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import Swal from 'sweetalert2';
import htmlToDraft from 'html-to-draftjs';
import { Formik, Form, Field } from 'formik';
import { dynamicSort } from '../../../common/utils/api_utils';
import CustomOption from './CustomOption';
import CollectionSelect from '../CollectionSelect';
import { EditorState, ContentState } from 'draft-js';
import CustomLoader from '../../common/CustomLoader';
import {
  AiMOdalValidationSchema,
  MailTemplateSchema,
  MailTemplateValidationSchema,
} from '../../../common/utils/smsMailTemplateValidationSchema';
import { getTemplateFormCollectionFieldOptions } from './MailTemplateFormUtil';
import { drapcodeIcon, iconForField } from '../../../common/custom/icon-library';
import CardTitleHeader from '../../../common/ui/CardTitleHeader';
import { CustomFieldModal } from './CustomFieldModal';
import { toast } from 'react-toastify';
import RestAPICollectionFieldsModal from '../../external-api/rest-api/RestAPICollectionFieldsModal';
import CustomSelect from '../../../common/formElements/CustomSelect';
import { BASE_AI_MODELS, createRedirectUrl } from '../../../common/utils/prompt-constants';
import CustomInputWithIconNoFormGroup from '../../../common/ui/CustomInputWithIconNoFormGroup';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import TooltipInfo from '../../../common/docs/TooltipInfo';

export default class MailTemplateForm extends Component {
  static propTypes = {
    editorState: PropTypes.object,
    value: PropTypes.object,
    projectDetail: PropTypes.object,
  };

  state = {
    editorState: this.props.editorState,
    name: this.props.name,
    subject: this.props.subject,
    collectionId: this.props.collectionId,
    selectedCollectionFields: this.props.selectedCollectionFields,
    addFieldsModal: false,
    subjectFieldsModal: false,
    attachmentField: this.props.attachmentField,
    openAIGenerationModal: false,
    generateContentPending: false,
    selectedAIModel: '',
    defaultAIModel: null,
  };

  componentDidUpdate(prevProps) {
    if (prevProps.projectDetail !== this.props.projectDetail) {
      this.setState({ projectDetail: this.props.projectDetail });
    }
    const prevConfigs = (prevProps.projectDetail && prevProps.projectDetail.aiModelConfigs) || [];
    const currentConfigs =
      (this.props.projectDetail && this.props.projectDetail.aiModelConfigs) || [];
    if (JSON.stringify(prevConfigs) !== JSON.stringify(currentConfigs)) {
      const enabledConfigs = currentConfigs.filter((cfg) => cfg.isEnabled);
      const defaultConfig = enabledConfigs.find((cfg) => cfg.isDefault);
      if (defaultConfig) {
        const base = BASE_AI_MODELS.find((opt) => opt.value === defaultConfig.modelType);
        const defaultAIModel = {
          label: base.label || defaultConfig.modelType,
          value: defaultConfig.modelType,
        };
        if (!this.state.selectedAIModel || this.state.defaultAIModel !== defaultAIModel.value) {
          this.setState({
            selectedAIModel: defaultAIModel.value,
            defaultAIModel: defaultAIModel.value,
          });
        }
      }
    }
  }

  componentDidMount() {
    const { projectDetail } = this.props;
    if (projectDetail && projectDetail.aiModelConfigs) {
      const enabledConfigs = projectDetail.aiModelConfigs.filter((cfg) => cfg.isEnabled);
      const defaultConfig = enabledConfigs.find((cfg) => cfg.isDefault);
      if (defaultConfig) {
        const base = BASE_AI_MODELS.find((opt) => opt.value === defaultConfig.modelType);
        const defaultAIModel = {
          label: base.label || defaultConfig.modelType,
          value: defaultConfig.modelType,
        };
        if (!this.state.selectedAIModel) {
          this.setState({
            selectedAIModel: defaultAIModel.value,
            defaultAIModel: defaultAIModel.value,
          });
        }
      }
    }
  }

  toggleAddFieldsModal = () => this.setState({ addFieldsModal: !this.state.addFieldsModal });

  toggleSubjectFieldsModal = () =>
    this.setState({ subjectFieldsModal: !this.state.subjectFieldsModal });

  onEditorStateChange = (editorState) => {
    this.setState({ editorState });
  };

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleSelectChange = (name, value) => {
    if (this.state['collectionId']) {
      Swal.fire({
        title: 'Editor selected fields will be removed by this.',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, change it!',
      }).then((result) => {
        if (result.isConfirmed) {
          this.setCollectionDataInState(value);
        }
      });
    } else {
      this.setCollectionDataInState(value);
    }
  };

  handleSubmit = (values) => {
    values = {
      ...values,
      collectionId: this.state.collectionId,
      templateType: 'EMAIL',
      content: draftToHtml(convertToRaw(this.state.editorState.getCurrentContent())),
      attachmentField: this.state.attachmentField,
    };
    this.props.handleSubmit(values);
  };

  updateStateAfterSave = (editorState, value) => {
    this.setState({ value: value, editorState: editorState });
  };

  collectionsOptions = () => {
    const { collections } = this.props;
    let options = [{ value: '', label: '-Select One-' }];
    options = options.concat(
      collections.sort(dynamicSort('collectionTitle')).map((collection) => {
        return { value: collection.collectionName, label: collection.collectionTitle };
      }),
    );
    return options;
  };

  setCollectionDataInState = (value) => {
    const { collections } = this.props;
    const selectedCollection = collections.find((e) => e.collectionName === value);
    let selectedCollectionFields = selectedCollection
      ? getTemplateFormCollectionFieldOptions(selectedCollection, collections)
      : [];
    let currentEditorContent = draftToHtml(
      convertToRaw(this.state.editorState.getCurrentContent()),
    );
    const regex = new RegExp(/{{(.*?)}}/g);
    currentEditorContent = currentEditorContent.replace(regex, '');
    console.log(currentEditorContent);
    const blocksFromHtml = htmlToDraft(currentEditorContent);
    const { contentBlocks, entityMap } = blocksFromHtml;
    const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
    const editorState = EditorState.createWithContent(contentState);
    this.setState({
      collectionId: value,
      selectedCollectionFields: selectedCollectionFields,
      editorState,
      attachmentField: '',
    });
  };

  copyToClipboard = (text) => {
    this.toggleSubjectFieldsModal();
    toast.success(text);
  };

  insertTextToParamInput = (textToInsert, setFieldValue) => {
    if (textToInsert) {
      let customSubjectElem = document.getElementById('subject');
      let start = customSubjectElem.selectionStart;
      let finish = customSubjectElem.selectionEnd;
      let allText = customSubjectElem.value;
      let sel = allText.substring(start, finish);
      let newText = '';
      if (sel) {
        newText = allText.replace(sel, textToInsert);
      } else {
        newText = allText + textToInsert;
      }
      this.setState({ subject: newText });
      setFieldValue('subject', newText);
      this.copyToClipboard('Text Inserted');
    }
  };

  showAddFieldsModal = (setFieldValue) => {
    const { collections, projectDetail } = this.props;
    const { collectionId, subjectFieldsModal } = this.state;
    const selectedCollection = collections.find((coll) => coll.collectionName === collectionId);
    return subjectFieldsModal ? (
      <RestAPICollectionFieldsModal
        selectedCollection={selectedCollection}
        collections={collections}
        projectDetail={projectDetail}
        copyToClipboard={() => this.copyToClipboard('Copied to clipboard')}
        insertTextToEditor={(textToInsert) =>
          this.insertTextToParamInput(textToInsert, setFieldValue)
        }
        toggleFields={subjectFieldsModal}
        toggleFieldsModal={this.toggleSubjectFieldsModal}
        hide={[
          'collectionConstants',
          'projectConstants',
          'authToken',
          'tenantFields',
          'userSettingFields',
          'subTenantFields',
        ]}
      />
    ) : (
      ''
    );
  };

  fetchFileFields = () => {
    const { collections } = this.props;
    const { collectionId } = this.state;
    const selectedCollection = collections.find((coll) => coll.collectionName === collectionId);
    if (!selectedCollection) return [{ value: '', label: '-Select One-' }];
    const fileFields = selectedCollection.fields
      .filter((field) => field.type === 'file')
      .map((field) => ({
        value: field.fieldName,
        label: field.fieldTitle.en || field.fieldName,
      }));
    return [{ value: '', label: '-Select One-' }, ...fileFields];
  };

  handleAttachmentSelectChange = (name, value) => {
    this.setState({ [name]: value });
  };

  openDataModal = () => {
    this.setState({ openAIGenerationModal: true });
  };

  toggleOpenDataModal = () => {
    this.setState(() => ({
      openAIGenerationModal: !this.state.openAIGenerationModal,
    }));
  };

  renderModal = () => {
    return (
      <>
        <Modal
          isOpen={this.state.openAIGenerationModal}
          toggle={this.toggleOpenDataModal}
          backdrop="static"
          size="lg"
        >
          <ModalHeader toggle={this.toggleOpenDataModal} className="border-bottom">
            AI Generated Mail Content
          </ModalHeader>
          <ModalBody>{this.generateAIMailTemplateView()}</ModalBody>
        </Modal>
      </>
    );
  };
  handleAiMOdalChange = (name, value) => {
    this.setState({ selectedAIModel: value });
  };

  generateAIMailTemplateView = () => {
    const { projectId, version, projectDetail } = this.props;
    const { generateContentPending } = this.state;
    let hasEnabledAIModelConfigs = false;
    let modelOptions = [];
    if (projectDetail && projectDetail.aiModelConfigs) {
      const enabledConfigs = projectDetail.aiModelConfigs.filter((cfg) => cfg.isEnabled);
      if (enabledConfigs.length > 0) {
        hasEnabledAIModelConfigs = true;
        modelOptions = enabledConfigs.map((cfg) => {
          const base = BASE_AI_MODELS.find((opt) => opt.value === cfg.modelType);
          return {
            label: base.label || cfg.modelType,
            value: cfg.modelType,
          };
        });
      }
    }
    let redirectUrl = createRedirectUrl();
    let aiModelConfigurationURL = `${redirectUrl}app-setting/${version}/v/${projectId}/setting/aiModelConfig-section`;

    return (
      <div className="form-horizontal position-relative">
        <Formik
          enableReinitialize={true}
          initialValues={{ aiModel: this.state.defaultAIModel, promptText: '' }}
          validationSchema={AiMOdalValidationSchema}
        >
          {({ values, setFieldValue }) => (
            <Form>
              <div className="form-group mb-3 position-relative z-3">
                <CustomInputWithIconNoFormGroup icon="text" title="Prompt Text" required={true}>
                  <input
                    type="text"
                    name="promptText"
                    className="form-control form-control-sm rounded-pill px-3 py-2 shadow-sm"
                    placeholder="A little bit about your Mail Template.."
                    value={values.promptText}
                    onChange={(e) => setFieldValue('promptText', e.target.value)}
                  />
                  <TooltipInfo
                    title="Enter a prompt that describes what kind of content you want the AI to generate."
                    headerText="Prompt Help"
                    showHeader={true}
                    showArrow={true}
                    append={true}
                  />
                </CustomInputWithIconNoFormGroup>
                <label className="mb-0">Select AI Model</label>
                <CustomInputWithIconNoFormGroup icon="dropdown" title="Select AI Model" required>
                  <CustomSelect
                    name="aiModel"
                    isMulti={false}
                    options={modelOptions}
                    value={values.aiModel}
                    onChange={setFieldValue}
                    onChangeValue={this.handleAiMOdalChange}
                    menuPlacement="top"
                    classNamePrefix="select"
                  />
                </CustomInputWithIconNoFormGroup>
              </div>
              {!hasEnabledAIModelConfigs && (
                <div className="text-danger mt-2 ml-6">
                  <i className="fa fa-warning" aria-hidden="true"></i>
                  Please configure the AI model in the{' '}
                  <a
                    href={aiModelConfigurationURL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="link-style"
                  >
                    AI Model Configuration{' '}
                    <i className="fa fa-external-link" aria-hidden="true"></i>
                  </a>
                  section.
                </div>
              )}

              <div className="col-md-12 col-lg-12 text-right">
                <button
                  type="button"
                  className={`btn btn-xs ${
                    generateContentPending ? 'btn-default' : 'btn-theme-submit'
                  }`}
                  onClick={async () => {
                    try {
                      await this.generateMailTemplateContent(values);
                    } catch (error) {
                      toast.error('Error generating content. Please try again.');
                    }
                  }}
                  disabled={
                    !this.state.selectedAIModel ||
                    !hasEnabledAIModelConfigs ||
                    !values.promptText ||
                    generateContentPending
                  }
                >
                  <i className="wb webconnect-save" />
                  &nbsp;Generate Content
                  <CustomLoader loading={generateContentPending} />
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    );
  };

  generateMailTemplateContent = async (values) => {
    this.setState({ generateContentPending: true });
    const { projectId, version } = this.props;
    const { projectDetail, actions } = this.props;
    const { selectedAIModel } = this.state;
    try {
      const selectedModelType = selectedAIModel || 'OPEN_AI';
      const aiModelConfig =
        (projectDetail.aiModelConfigs || []).find((cfg) => cfg.modelType === selectedModelType) ||
        {};
      const apiKey =
        (aiModelConfig && aiModelConfig.setting && aiModelConfig.setting.secretKey) || '';
      const modelType =
        (aiModelConfig && aiModelConfig.setting && aiModelConfig.setting.modelType) ||
        selectedModelType;
      const collectionField = this.state.selectedCollectionFields
        .map(({ fieldName, fieldTitle }) => `- ${fieldTitle}: \`{{${fieldName}}}\``)
        .join('\n');
      const userPrompt = `
         "userPrompt" : ${values.promptText}
        "filedList:${collectionField}"
        "content" :${
          this.state.editorState
            ? this.state.editorState.getCurrentContent().getPlainText('\n')
            : ''
        }
      `;
      const args = {
        generatedCodeConfig: 'emailTemplate',
        generationType: 'create',
        userPrompt: userPrompt,
        apiKey,
        aiModel: modelType,
        projectId,
        version,
      };
      const generatedContent = await actions.generateTemplate(args);

      if (generatedContent && generatedContent.data) {
        const input = generatedContent.data.data;
        const blocksFromHtml = htmlToDraft(input);
        const { contentBlocks, entityMap } = blocksFromHtml;
        const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
        const newEditorState = EditorState.createWithContent(contentState);
        this.setState({
          editorState: newEditorState,
          openAIGenerationModal: false,
        });
        toast.success('Mail template content generated successfully!');
      }
    } catch (error) {
      toast.error('Error generating content. Please try again.');
    } finally {
      this.setState({ generateContentPending: false });
    }
  };

  render() {
    const { editorState, collectionId, selectedCollectionFields } = this.state;
    const {
      updateTemplatePending,
      createMailTemplatePending,
      templateId,
      collections,
      projectDetail,
      name,
      subject,
      isReadOnly,
    } = this.props;
    MailTemplateSchema.name = name ? name : '';
    MailTemplateSchema.subject = subject ? subject : '';
    return (
      <>
        <CardTitleHeader title={`${templateId ? 'Edit' : 'Create'} Mail Template`} />
        {this.renderModal()}
        <Formik
          enableReinitialize={true}
          initialValues={MailTemplateSchema}
          validationSchema={MailTemplateValidationSchema}
          onSubmit={(values, { setSubmitting, resetForm }) => {
            !isReadOnly && this.handleSubmit(values);
            setSubmitting(false);
            //resetForm();
          }}
        >
          {({ errors, touched, values, setFieldValue }) => (
            <Form className="form-horizontal">
              <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                <div className="form-group">
                  <span className="label text-muted">Name</span>
                  <div className="input-group">
                    <div className="input-group-prepend">
                      <span className="input-group-text">
                        <i className={`wb ${iconForField('text')}`}></i>
                      </span>
                    </div>
                    <Field type="text" name="name" className="form-control" placeholder="Name" />
                    {touched.name && errors.name && <p className="errors">{errors.name}</p>}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-11 col-lg-11 col-sm-11 col-xs-11 ml-3">
                  <span className="label text-muted">Collection</span>
                  <CollectionSelect
                    options={this.collectionsOptions}
                    value={collectionId}
                    onChange={this.handleSelectChange}
                  />
                </div>
                <div className="input-group-append">
                  <span
                    className="input-group-text"
                    data-tip="Mail Template"
                    title=" Shows you the list of collections you have created in your web app builder. You can select the collection that contains the details of the customers along with an email address field to which you want to send the email."
                  >
                    <i className={`wb ${drapcodeIcon('description')}`}></i>
                  </span>
                </div>
              </div>
              <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                <div className="form-group">
                  <span className="label text-muted">Subject</span>
                  <div className="input-group">
                    <div className="input-group-prepend">
                      <span className="input-group-text">
                        <i className={`wb ${iconForField('text')}`}></i>
                      </span>
                    </div>
                    <Field
                      id="subject"
                      type="text"
                      name="subject"
                      className="form-control"
                      placeholder="Subject"
                    />
                    <button
                      type="button"
                      className="btn btn-theme-submit btn-xs btn-icon-only"
                      title={isReadOnly ? 'Read-Only Mode' : 'Add Fields'}
                      onClick={isReadOnly ? null : this.toggleSubjectFieldsModal}
                      disabled={isReadOnly}
                    >
                      <i className="wb webconnect-plus" />
                    </button>
                    {this.showAddFieldsModal(setFieldValue)}
                    {touched.subject && errors.subject && (
                      <p className="errors">{errors.subject}</p>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                <div className="form-group">
                  <span className="label text-muted">Content</span>
                  <div className="input-group">
                    <div className="input-group-prepend">
                      <span className="input-group-text">
                        <i className={`wb ${iconForField('text')}`}></i>
                      </span>
                    </div>
                    <Editor
                      editorState={editorState}
                      editorClassName="form-control mail-editor border-left-editor border-right-editor"
                      wrapperClassName="form-group form-control h-auto no-bg-img"
                      onEditorStateChange={this.onEditorStateChange}
                      placeholder="Content"
                      toolbarCustomButtons={[
                        <CustomOption selectedCollectionFields={selectedCollectionFields} />,
                        <CustomFieldModal
                          collectionId={collectionId}
                          collections={collections}
                          addFieldsModal={this.state.addFieldsModal}
                          toggleAddFieldsModal={this.toggleAddFieldsModal}
                          projectDetail={projectDetail}
                          isReadOnly={isReadOnly}
                        />,
                        <div className="d-flex justify-content-end align-items-center ml-2">
                          <button
                            type="button"
                            className="btn btn-primary btn-md mr-2"
                            onClick={() => {
                              if (isReadOnly) return;
                              this.generateAIMailTemplateView();
                              this.openDataModal();
                            }}
                            disabled={isReadOnly}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 576 512"
                              width="16"
                              height="16"
                              className="mr-1"
                              style={{ verticalAlign: 'middle', fill: 'white' }}
                            >
                              <path d="M234.7 42.7L197 56.8c-3 1.1-5 4-5 7.2s2 6.1 5 7.2l37.7 14.1L248.8 123c1.1 3 4 5 7.2 5s6.1-2 7.2-5l14.1-37.7L315 71.2c3-1.1 5-4 5-7.2s-2-6.1-5-7.2L277.3 42.7 263.2 5c-1.1-3-4-5-7.2-5s-6.1 2-7.2 5L234.7 42.7zM46.1 395.4c-18.7 18.7-18.7 49.1 0 67.9l34.6 34.6c18.7 18.7 49.1 18.7 67.9 0L529.9 116.5c18.7-18.7 18.7-49.1 0-67.9L495.3 14.1c-18.7-18.7-49.1-18.7-67.9 0L46.1 395.4zM484.6 82.6l-105 105-23.3-23.3 105-105 23.3 23.3zM7.5 117.2C3 118.9 0 123.2 0 128s3 9.1 7.5 10.8L64 160l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L128 160l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L128 96 106.8 39.5C105.1 35 100.8 32 96 32s-9.1 3-10.8 7.5L64 96 7.5 117.2zm352 256c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L416 416l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L480 416l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L480 352l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L416 352l-56.5 21.2z" />
                            </svg>
                            Generate Content&nbsp;
                          </button>
                        </div>,
                      ]}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                <div className="form-group">
                  <span className="label text-muted">Attachment</span>
                  <div className="input-group">
                    <div className="input-group-prepend">
                      <span className="input-group-text">
                        <i className="wb webconnect-paperclip" />
                      </span>
                    </div>
                    <CustomSelect
                      name="attachmentField"
                      isMulti={false}
                      value={this.state.attachmentField || ''}
                      options={this.fetchFileFields()}
                      onChange={this.handleAttachmentSelectChange}
                      onBlur={this.handleBlur}
                      placeholder="Select Attachment Field"
                      isDisabled={false}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 text-right">
                <button
                  style={{ marginBottom: '20px' }}
                  type="submit"
                  className="btn btn-theme-submit btn-md"
                  disabled={isReadOnly}
                  title={isReadOnly && 'Read-Only Mode'}
                >
                  <i className={`wb ${drapcodeIcon('save')}`}></i>
                  &nbsp;{templateId ? 'Update' : 'Save'}&nbsp;
                  <CustomLoader
                    loading={
                      (updateTemplatePending !== undefined && updateTemplatePending) ||
                      (createMailTemplatePending !== undefined && createMailTemplatePending)
                    }
                  />
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </>
    );
  }
}
